import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js';
import { getConfig } from './config';

let userPool = null;

function getUserPool() {
  if (!userPool) {
    const cfg = getConfig();
    userPool = new CognitoUserPool({
      UserPoolId: cfg.userPoolId,
      ClientId: cfg.userPoolClientId,
    });
  }
  return userPool;
}

export function getCurrentUser() {
  return getUserPool().getCurrentUser();
}

export function getSession() {
  return new Promise((resolve, reject) => {
    const user = getCurrentUser();
    if (!user) return reject(new Error('No user'));
    user.getSession((err, session) => {
      if (err) return reject(err);
      resolve(session);
    });
  });
}

export async function getToken() {
  try {
    const session = await getSession();
    return session.getIdToken().getJwtToken();
  } catch {
    return null;
  }
}

export function signIn(email, password) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: getUserPool() });
    const authDetails = new AuthenticationDetails({ Username: email, Password: password });
    user.authenticateUser(authDetails, {
      onSuccess: (result) => resolve({ type: 'success', result }),
      onFailure: (err) => reject(err),
      newPasswordRequired: (userAttributes) => resolve({ type: 'newPassword', user, userAttributes }),
      totpRequired: () => resolve({ type: 'mfa', user }),
    });
  });
}

export function completeMfa(user, code) {
  return new Promise((resolve, reject) => {
    user.sendMFACode(code, {
      onSuccess: (result) => resolve(result),
      onFailure: (err) => reject(err),
    }, 'SOFTWARE_TOKEN_MFA');
  });
}

export function completeNewPassword(user, newPassword) {
  return new Promise((resolve, reject) => {
    user.completeNewPasswordChallenge(newPassword, {}, {
      onSuccess: (result) => resolve(result),
      onFailure: (err) => reject(err),
      mfaSetup: () => resolve({ type: 'mfaSetup', user }),
    });
  });
}

export function signOut() {
  const user = getCurrentUser();
  if (user) user.signOut();
}
